import { Component, OnInit } from '@angular/core';
import { AppService } from '../../../app.service';

@Component({
  selector: 'navbar-top',
  templateUrl: './navbar-top.component.html',
  styleUrls: ['./navbar-top.component.scss']
})
export class NavbarTopComponentIdentity implements OnInit {
    UCUri: string = '';
    GETUri: string = '';
    IdentityServerUri: string = '';
    TTLogoImagePath: string = '/api/Application/DealershipLogo/';

    constructor(private _appService: AppService) { }

  ngOnInit() {
  }
  toggleMenu() {
      this._appService.toggleMenuVisible();
  }
}
